import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCog } from "@fortawesome/free-solid-svg-icons"

export const Cog = (props) => {
  return <FontAwesomeIcon faIcon={faCog} {...props} />
}
